import { initialState, AppointmentsState, appointmentsAdapter } from './appointments.interfaces';
import * as fromAppointments from './appointments.actions';

export function reducer(state = initialState, action: fromAppointments.AppointmentsAction): AppointmentsState {
  switch (action.type) {
    case fromAppointments.GET_APPOINTMENT_FROM_SERVER_SUCCESS: {
      return {
        ...appointmentsAdapter.addOne(action.payload, state)
      };
    }

    default: {
      return state;
    }
  }
}
